var Flickity = require("flickity");
require("flickity-fullscreen");
require("flickity-as-nav-for");

$(".carousel-main").each(function () {
    let flickitySettings = {
        "fullscreen": true,
        "lazyLoad": 2,
        "pageDots": true,
        "adaptiveHeight": true,
        on: {
            ready: function () {
                $(".carousel-main.force-square-image .carousel-cell img").each(function () {
                    $(this).height($(".carousel-main.force-square-image .flickity-viewport").width());
                });
                $(".carousel-main.force-square-image .flickity-viewport").height($(".carousel-main .flickity-viewport").width());

                if ($(".carousel-main .carousel-cell").length <= 1) {
                    $(".carousel-main .flickity-prev-next-button.previous").hide();
                    $(".carousel-main .flickity-prev-next-button.next").hide();
                    $(".carousel-main .flickity-page-dots").hide();
                }
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    new Flickity(this, flickitySettings);
});

$(".carousel-nav").each(function () {
    let flickitySettings = {
        "lazyLoad": 6,
        "asNavFor": ".carousel-main",
        "pageDots": false,
        "contain": true,
        "prevNextButtons": false,
        "cellAlign": 'left',
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    new Flickity(this, flickitySettings);
});

$(".carousel-catalog").each(function () {
    let flickitySettings = {
        "lazyLoad": 1,
        "wrapAround": true,
        "autoPlay": true,
        "setGallerySize": false,
        on: {
            ready: function () {
                if ($(".carousel-catalog .carousel-cell").length <= 1) {
                    $(".carousel-catalog .flickity-prev-next-button.previous").hide();
                    $(".carousel-catalog .flickity-prev-next-button.next").hide();
                    $(".carousel-catalog .flickity-page-dots").hide();
                }
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    new Flickity(this, flickitySettings);
});

$(".carousel-content").each(function () {
    let flickitySettings = {
        "lazyLoad": 1,
        "wrapAround": true,
        "autoPlay": true,
        on: {
            ready: function () {
                if ($(".carousel-content .carousel-cell").length <= 1) {
                    $(".carousel-content .flickity-prev-next-button.previous").hide();
                    $(".carousel-content .flickity-prev-next-button.next").hide();
                    $(".carousel-content .flickity-page-dots").hide();
                }
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    let flickityBlockSettings = $(this).data("flickity-additional-block-settings");
    flickitySettings = {...flickitySettings, ...flickityBlockSettings}

    new Flickity(this, flickitySettings);
});

//slider widget lista categorie
$(".carousel-catalog-list").each(function () {
    let flickitySettings = {
        "groupCells": true,
        on: {
            ready: function () {
                var height = this.maxCellHeight;
                $(".carousel-catalog-list .carousel-cell").each(function () {
                    $(this).height(height);
                });

                $(".carousel-catalog-list .carousel-cell > *").each(function () {
                    $(this).outerHeight(height);
                });
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    let flickityBlockSettings = $(this).data("flickity-additional-block-settings");
    flickitySettings = {...flickitySettings, ...flickityBlockSettings}

    new Flickity(this, flickitySettings);
});

//slider widget lista prodotti
$(".carousel-product-list").each(function () {
    let flickitySettings = {
        "groupCells": true,
        on: {
            ready: function () {
                var height = this.maxCellHeight;
                $(".carousel-product-list .carousel-cell").each(function () {
                    $(this).height(height);
                });

                $(".carousel-product-list .carousel-cell > *").each(function () {
                    $(this).outerHeight(height);
                });
            }
        }
    };

    let customFlickitySettings = $(this).data("flickity");
    flickitySettings = {...flickitySettings, ...customFlickitySettings}

    let flickityBlockSettings = $(this).data("flickity-additional-block-settings");
    flickitySettings = {...flickitySettings, ...flickityBlockSettings}

    new Flickity(this, flickitySettings);
});
